export default __webpack_public_path__ + "images/335c37d905cc0c8238e366a88d62b481.svg";